import Table from '../common/Table'

const CurriculumVideoHeader = () => {
  return (
    <tr>
      <Table.Header>Level</Table.Header>
      <Table.Header>Main Chapter</Table.Header>
      <Table.Header>Sub Chapter</Table.Header>
      <Table.Header>Unit</Table.Header>
      <Table.Header>Detail Unit</Table.Header>
      <Table.Header>Content Type</Table.Header>
      <Table.Header>Depth</Table.Header>
    </tr>
  )
}

export default CurriculumVideoHeader
